// extracted by mini-css-extract-plugin
export var table = "_wd-0";